// import React from "react";
// import styled, { keyframes } from "styled-components";
// import { motion } from "framer-motion";
// import { PhoneCall } from "lucide-react";
// import { gradients } from "./theme/theme";
// const bubbleFloat = keyframes`
//   0% {
//     transform: translateY(0) scale(0.8);
//     opacity: 0.5;
//   }
//   50% {
//     transform: translateY(-100px) scale(1);
//     opacity: 0.8;
//   }
//   100% {
//     transform: translateY(-200px) scale(0.9);
//     opacity: 0;
//   }
// `;
// const floatSymbol = keyframes`
//   0% {
//     transform: translateY(0) scale(1);
//     opacity: 0.2;
//   }
//   50% {
//     transform: translateY(-200px) scale(1.1);
//     opacity: 0.5;
//   }
//   100% {
//     transform: translateY(-300px) scale(0.9);
//     opacity: 0;
//   }
// `;
// const gradientBG = keyframes`
//   0%, 100% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
// `;

// const float = keyframes`
//   0% { transform: translateY(0) scale(1); }
//   50% { transform: translateY(-20px) scale(1.05); }
//   100% { transform: translateY(0) scale(1); }
// `;

// const HeroSection = styled.section`
//   position: relative;
//   background: ${gradients.heroBackground};
//   background-size: 400% 400%;
//   animation: ${gradientBG} 15s ease infinite;
//   min-height: 100vh;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: white;
//   padding: 0 1.5rem;
//   text-align: center;
//   flex-direction: column;
//   overflow: hidden;

//   &::before,
//   &::after {
//     content: "";
//     position: absolute;
//     border-radius: 50%;
//     opacity: 0.1;
//     filter: blur(100px);
//     animation: ${float} 6s ease-in-out infinite;
//   }

//   &::before {
//     width: 400px;
//     height: 400px;
//     background: #ff6b00;
//     top: -100px;
//     left: -150px;
//   }

//   &::after {
//     width: 300px;
//     height: 300px;
//     background: #00ff99;
//     bottom: -120px;
//     right: -100px;
//     animation-delay: 3s;
//   }
// `;

// const Title = styled.h1`
//   font-size: 5.6rem;
//   font-weight: 700;
//   line-height: 1.2;
//   margin-bottom: 1rem;
//   max-width: 90%;
//   text-align: center;
//   word-break: break-word;

//   @media (max-width: 1024px) {
//     font-size: 3.5rem;
//   }

//   @media (max-width: 768px) {
//     font-size: 2.8rem;
//   }

//   @media (max-width: 480px) {
//     font-size: 2.8rem;
//   }
// `;

// const Subtitle = styled.p`
//   color: #cccccc;
//   max-width: 800px;
//   font-size: 1.1rem;
//   margin-bottom: 2.5rem;
// `;

// const ButtonGroup = styled.div`
//   display: flex;
//   gap: 1rem;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// const PrimaryButton = styled(motion.button)`
//   background-color: #ff6b00;
//   color: #fff;
//   padding: 0.9rem 1.8rem;
//   border: none;
//   border-radius: 10px;
//   font-size: 1rem;
//   font-weight: 600;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   &:hover {
//     transform: scale(1.05);
//     box-shadow: 0 0 12px #ff6b00;
//   }
// `;

// const SecondaryButton = styled(motion.button)`
//   background: transparent;
//   color: #fff;
//   border: none;
//   font-size: 1rem;
//   font-weight: 500;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   text-decoration: underline;
//   transition: all 0.3s ease;
//   &:hover {
//     color: #ff6b00;
//   }
// `;

// const SymbolsContainer = styled.div`
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   overflow: hidden;
//   z-index: 0;
//   pointer-events: none;
// `;

// const Symbol = styled.span`
//   position: absolute;
//   bottom: -50px;
//   font-size: ${(props) => props.size}px;
//   color: ${(props) => props.color || "#00ff99"};
//   opacity: 0.3;
//   animation: ${floatSymbol} ${(props) => props.duration || 10}s ease-in infinite;
//   left: ${(props) => props.left}%;
//   animation-delay: ${(props) => props.delay}s;
//   font-family: monospace;
// `;

// export default function Hero() {
//   return (
//     <HeroSection>
//       <SymbolsContainer>
//         <Symbol size={32} left={10} color="#00ff99" duration={10} delay={0}>
//           {"{ }"}
//         </Symbol>
//         <Symbol size={36} left={25} color="#ff6b00" duration={6} delay={1}>
//           {"</>"}
//         </Symbol>
//         <Symbol size={28} left={40} color="#00ccff" duration={8} delay={2}>
//           {"[ ]"}
//         </Symbol>
//         <Symbol size={34} left={55} color="#ff00cc" duration={15} delay={0.5}>
//           {"()"}
//         </Symbol>
//         <Symbol size={30} left={70} color="#ffaa00" duration={12} delay={1.2}>
//           {"</>"}
//         </Symbol>
//         <Symbol size={26} left={85} color="#00ffaa" duration={10} delay={0.8}>
//           {"{ }"}
//         </Symbol>
//       </SymbolsContainer>
//       <Title>Your One-Stop Tech Solution Provider</Title>
//       <Subtitle>
//         From concept to code to launch — we design, build, and maintain
//         full-scale mobile apps, websites, and robust backends. Whether you're a
//         startup or a scaling business, we’re your engineering partner for every
//         digital need.
//       </Subtitle>
//       <ButtonGroup>
//         <PrimaryButton whileTap={{ scale: 0.95 }}>
//           See All Project
//         </PrimaryButton>
//         <SecondaryButton whileTap={{ scale: 0.95 }}>
//           <PhoneCall size={18} />
//           Let's Connect
//         </SecondaryButton>
//       </ButtonGroup>
//     </HeroSection>
//   );
// }

import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import { BriefcaseBusiness, Edit, PhoneCall, Wrench } from "lucide-react";
import { gradients } from "./theme/theme";
import ContactModal from "./components/ContactModal";
import { ReactTyped } from "react-typed";
import { useNavigate } from "react-router-dom";

const gradientBG = keyframes`
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
`;

const float = keyframes`
  0% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-15px) scale(1.05); }
  100% { transform: translateY(0) scale(1); }
`;

const floatSymbol = keyframes`
  0% { transform: translateY(0) rotate(0deg); opacity: 0.3; }
  50% { transform: translateY(-200px) rotate(20deg); opacity: 0.6; }
  100% { transform: translateY(-400px) rotate(-20deg); opacity: 0; }
`;

const HeroSection = styled.section`
  position: relative;
  background: ${gradients.heroBackground};
  background-size: 400% 400%;
  animation: ${gradientBG} 12s ease infinite;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem;
  color: white;
  overflow: hidden;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 5rem;
  font-weight: 800;
  background: linear-gradient(90deg, #ff6b00, #ff00cc, #00ff99);
  background-size: 200% auto;
  color: transparent;
  background-clip: text;
  animation: ${gradientBG} 5s linear infinite;
  margin-bottom: 1rem;
  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.8);
  max-width: 800px;
  font-size: 1.2rem;
  margin-bottom: 3rem;
  line-height: 1.6;
`;

const ButtonGroup = styled(motion.div)`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  animation: ${float} 6s ease-in-out infinite;
`;

const PrimaryButton = styled(motion.button)`
  background: linear-gradient(90deg, #ff6b00, #ff8a33);
  color: white;
  padding: 0.9rem 2rem;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  align-items: center;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 0 20px #ff6b00;
    transform: scale(1.05);
  }
`;

const SecondaryButton = styled(motion.button)`
  background: transparent;
  border: 2px solid white;
  color: white;
  padding: 0.9rem 1.8rem;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    color: #ff6b00;
    border-color: #ff6b00;
  }
`;

const SymbolsContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 0;
`;

const Symbol = styled.span`
  position: absolute;
  bottom: -50px;
  font-size: ${(p) => p.size}px;
  color: ${(p) => p.color};
  animation: ${floatSymbol} ${(p) => p.duration}s linear infinite;
  left: ${(p) => p.left}%;
  animation-delay: ${(p) => p.delay}s;
`;

export default function Hero() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <HeroSection>
      <SymbolsContainer>
        <Symbol size={34} left={10} color="#00ff99" duration={12} delay={0}>
          {"{ }"}
        </Symbol>
        <Symbol size={38} left={25} color="#ff6b00" duration={10} delay={1}>
          {"</>"}
        </Symbol>
        <Symbol size={30} left={45} color="#00ccff" duration={14} delay={2}>
          {"[ ]"}
        </Symbol>
        <Symbol size={36} left={60} color="#ff00cc" duration={9} delay={1.5}>
          {"()"}
        </Symbol>
        <Symbol size={32} left={75} color="#ffaa00" duration={11} delay={0.8}>
          {"</>"}
        </Symbol>
        <Symbol size={28} left={90} color="#00ffaa" duration={13} delay={0.5}>
          {"{ }"}
        </Symbol>
      </SymbolsContainer>

      {/* ✅ Only one Title */}
      <Title>
        <ReactTyped
          strings={[
            "Your One-Stop Tech Solution Provider",
            "Learn With Us & Upgrade Your Skills",
            "Budget-Friendly Courses for Developers",
          ]}
          typeSpeed={70}
          backSpeed={70}
          showCursor={true}
          loop
        />
      </Title>

      {/* ✅ Updated subtitle to cover both portfolio + courses */}
      <Subtitle>
        We showcase our engineering portfolio while helping learners grow
        through practical, budget-friendly courses. From apps to full-stack web
        development, explore our projects and gain skills that matter for your
        career.
        {/* Learn practical, budget-friendly courses designed to boost your career.
        From app development to full-stack web, gain real skills that matter in
        the industry. */}
      </Subtitle>

      <ButtonGroup>
        <PrimaryButton
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate("/courses")}
        >
          View Courses
        </PrimaryButton>
        <SecondaryButton
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate("/react-native-interview-questions")}
        >
          React Native Interview Preparation
        </SecondaryButton>
      </ButtonGroup>

      <ContactModal
        isOpen={isContactOpen}
        onClose={() => setIsContactOpen(false)}
      />
    </HeroSection>
  );
}
